import React from "react";
import "./Fundraiser.scss";
import { Button } from "antd";
import fundraiserProcessImage from "../../../assets/images/Soccer1.png";
import beekeperImage from "../../../assets/images/beekeper.jpg";
import honeyPotImage from "../../../assets/images/honey-pot.jpg";

export default function FundraiserInfoComponent() {
  const windowWidth = window?.innerWidth;
  return (
    <div className="fundraiser">
      <div className="fundraiser-page-heading">
        <div className="title">Kicking the Fundraiser Goal in 3 steps!</div>
      </div>
      <div className="content">
        <div className="image-container">
          <img className="fh-process-image" src={fundraiserProcessImage} alt="" />
        </div>
        <div className="content-container">
          <p>Experience the simplicity of fundraising with our three-step process.</p>
          <p className="sub-headers">Step 1 — Quick Consultation</p>
          <p>Start with a 20-minute call with one of our LFT team members. Together, we’ll outline your fundraising goals and set your group up for success.</p>
          <p className="sub-headers">Step 2 — Easy Setup & Sharing</p>
          <p>Your team members are seamlessly on boarded to the LFT platform. Each member receives a unique link, making it easy to share your fundraiser and our curated product selection with friends, family, and supporters nationwide.</p>
          <p className="sub-headers">Step 3 — Earn & Celebrate</p>
          <p> Your group earns a 20% commission on every sale generated through their unique links. Once the fundraiser concludes, commissions are promptly disbursed—making fundraising simple, rewarding, and effective.</p>
        </div>
      </div >
      <div className="fundraiser-page-heading second-header">
        <div className="title">Together, we’re growing fundraisers and spotlighting inspiring brands.</div>
      </div>
      <div className="content second-content">
        <div className="image-container">
          <img className="base-img" src={beekeperImage} alt="beekeeper" />
          <img className="top-img" src={honeyPotImage} alt="honey pot" />
        </div>
        <div className="content-container">
          <p>When you purchase through LFT fundraisers, you’re not only supporting a great cause—you’re also backing amazing companies with inspiring founding stories. </p>
          <br />
          <p>We handpick products from quality brands that often sit outside the mainstream, giving those businesses the chance to reach new customers. By keeping prices as close as possible to recommended retail, you get excellent value while helping both the fundraiser and these passionate companies thrive.
          </p>
          <br />
          <p>At LFT, every purchase powers your fundraiser while supporting the hardworking suppliers behind our great products. It’s fundraising that gives back in more ways.
</p>
          {/* <a href="https://www.umf.org.nz/nz-manuka-honey/" target="_blank" rel="noreferrer">
            <Button className="readmore-btn">
              {windowWidth >= 768 ?
                <span className="btn-text">Find out more about the health benefits of Mānuka Honey</span>
                :
                <span className="btn-text">Know more about Mānuka Honey</span>
              }
            </Button>
          </a> */}
        </div>
      </div>
    </div >
  );
}